module.exports = __webpack_public_path__ + "static/img/iPhone6Plus.92f9b463.png";